<mat-form-field class="w-100">
  <mat-label for="input" *ngIf="label">{{label}}</mat-label>
  <input [type]="numberInput ? 'number' : 'text'" matInput #input id="input" [formControl]="inputForm"
    [matAutocomplete]="auto" (blur)="onBlur($event)" (focus)="onFocus($event)" (keydown.enter)="onBlur($event)" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
    <mat-option *ngIf="emptySelection" (click)="clearSelection()"></mat-option>
    <mat-option *ngFor="let option of (filteredOptions$ | async)" [value]="option"
      [title]="display || filterBy ? option[display || filterBy] || option : option">
      {{display || filterBy ? option[display || filterBy] || option : option}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>